<template>
    <div class="nav_box">
        <div v-show="navState == 1" class="flight_nav">
            <ul class="clear">
<!--              <router-link class="left" to="/checkin" tag="li">-->
<!--                <a href="javascript:;" class="cl_a">Online Checkin<span class="right"></span></a>-->
<!--              </router-link>-->
<!--              <router-link class="left" to="/status" tag="li">-->
<!--                <a href="javascript:;" class="cl_a">Flight Status<span class="right"></span></a>-->
<!--              </router-link>-->
<!--              <router-link class="left" to="/management" tag="li">-->
              <!--                <a href="javascript:;" class="cl_a">Order Management<span class="right"></span></a>-->
              <!--              </router-link>-->
            </ul>
        </div>
        <div v-show="navState == 2" class="flight_nav">
            <ul class="clear">
              <li class="left" v-for="(item,index) in offerData" :key="index">
                <router-link :to="{path:'/specialoffer',query: {filetext: item.fileText}}" class="cl_a" v-if="item.officeIdStr?item.officeIdStr.indexOf(OfficeID) >-1?true:false:true">
                  {{item.nodeTitle}}<span class="right"></span>
                </router-link>
                <ul class="cl_ul" v-if="item.childrens?item.childrens.length != 0:false">
                  <li v-for="(i,k) in item.childrens" :key="k" v-show="i.officeIdStr?i.officeIdStr.indexOf(OfficeID) >-1?true:false:true">
                    <router-link :to="{path:'/specialoffer',query: {filetext: i.fileText}}">{{i.title}}</router-link>
                  </li>
                </ul>
              </li>
            </ul>
        </div>
        <div v-show="navState == 3" class="flight_nav">
            <ul class="clear">
              <li class="left" style="height:220px;line-height:100%;overflow-y: auto;width: 350px;" v-for="(item,index) in informationData" :key="index">
                <a href="javascript:;" style="line-height:48px;height:48px;" class="cl_a"
                v-if="item.officeIdStr?item.officeIdStr.indexOf(OfficeID) >-1?true:false:true">
                  {{item.nodeTitle}}<span class="right"></span>
                </a>
                <ul class="cl_ul" v-if="item.childrens?item.childrens.length != 0:false">
                  <li v-for="(i,k) in item.childrens" :key="k" v-show="i.officeIdStr?i.officeIdStr.indexOf(OfficeID) >-1?true:false:true">
                    <router-link v-if="i.isNode =='Y'" :to="{path:'/information',query: {key1: `${index+1}`,key2:`${index+1}.${k+1}`}}" :title="i.nodeTitle" style=" overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{i.nodeTitle}}</router-link>
                  </li>
                </ul>
              </li>
            </ul>
        </div>
        <!-- <div v-show="navState == 4" class="flight_nav">
            <ul class="clear">
              <li class="left">
                <a href="javascript:;" class="cl_a">Online Checkin<span class="right"></span></a>
                <ul class="cl_ul">
                  <li><a href="javascript:;">Pregnant/Postpartum passenger, Infant</a></li>
                  <li><a href="javascript:;">Pregnant/Postpartum passenger, Infant</a></li>
                  <li><a href="javascript:;">Pregnant/Postpartum passenger, Infant</a></li>
                  <li><a href="javascript:;">Pregnant/Postpartum passenger, Infant</a></li>
                </ul>
              </li>
              <li class="left">
                <a href="javascript:;" class="cl_a">Order Management<span class="right"></span></a>
              </li>
              <li class="left">
                <a href="javascript:;" class="cl_a">Order Management<span class="right"></span></a>
              </li>
            </ul>
        </div> -->
    </div>
</template>

<script>
export default {
  components: {},
  name: "Nav",
  data() {
    return {
      OfficeID:''
    };
  },
  props: {
    navState: {
      type: Number,
    },
    navData:{
      type:Array
    },
    offerData:{
      type:Array
    },
    informationData:{
      type:Array
    },
  },
  watch: {},
  methods: {},
  filters: {},
  computed: {},
  created() {
    let OfficeID = this.$Utils.getSession('COUNTRY_OfficeID')
    this.OfficeID = OfficeID
  },
  mounted() {},
  destroyed() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.nav_box{
    width: 1184px;
    color: #333333;
    .flight_nav{
      padding: 32px 32px 144px;
      ul{
        li{
          height:48px;
          line-height: 48px;
          background:#fff;
          margin-right: 16px;
          &:last-child{
            margin-right: 0;
          }
          .cl_a{
            display: inline-block;
            width: 330px;
            font-size:16px;
            font-family:SFUIText-Regular,SFUIText;
            font-weight:400;
            color:rgba(51,51,51,1);
            border-bottom: 1px solid rgba(236,238,240,1);
            &:hover{
              background:#f6f6f6;
            }
            span{
              width: 16px;
              height: 16px;
              display: inline-block;
              background: url(../../assets/common/icon_next_grey.png) no-repeat center;
              background-size: 100% 100%;
              margin-top: 16px;
              margin-right: 16px;
            }
          }
          .cl_ul{
            li{
              font-size:14px;
              font-family:SFUIText-Regular,SFUIText;
              font-weight:400;
              color:rgba(128,128,128,1);
              height: 32px;
              margin-right: 0;
              &:hover{
                background:#f6f6f6;
              }
              a{
                display: block;
                font-size:14px;
                font-family:SFUIText-Regular,SFUIText;
                font-weight:400;
                color:rgba(128,128,128,1);
                line-height:32px;
              }
            }
          }
        }
      }
    }
}
</style>
